import $ from 'jquery';
import React from 'react';
import {showCountrySelectionDialog} from 'app/components/country_selection';
import InvalidEmail from 'app/components/invalid_email';
import MessageNotification from 'app/components/message_notification';
import {showWarningMessage} from 'app/utils';
import {loadAndShowTerms} from 'app/utils/modals/popups';
import {showPopup} from 'app/utils/modals/ModalsService';
import {showAuthForm} from 'app/components/auth/auth';
import {showTelegramLinkConfirmation} from 'app/components/telegram/telegram_link';
import {showSteamLinkConfirmation, showSteamAuthError, showSteamRegistrationSuccess} from 'app/utils/steamLink';
import {showGoogleAuthError, showGoogleRegistrationSuccess} from 'app/utils/googleAuth';
import {userStore} from './store/global';

const runCallbacks = () => {
    showAuthForm();
    showGoogleAuthError();
    showGoogleRegistrationSuccess();
    showSteamAuthError();
    showSteamRegistrationSuccess();

    if (userStore.user.user_id) {
        showTelegramLinkConfirmation(Boolean(userStore.user.telegram_user_id));
        showSteamLinkConfirmation(Boolean(userStore.user.steam_account.steam_id));
    }

    if (userStore.user.warning_message) {
        $(() => showWarningMessage());
    }
    if (userStore.user.user_id && !userStore.user.terms) {
        $(() => loadAndShowTerms());
    }
    if (userStore.user.invalid_email) {
        $(() => showPopup('invalid-email', props => <InvalidEmail popupId={props.popupId}/>));
    }
    if (userStore.user.user_id && userStore.user.unknown_country_code && userStore.user.full_registered) {
        $(() => showCountrySelectionDialog());
    }
    if (userStore.user.message_notification) {
        $(() => showPopup('message-notification', props => <MessageNotification popupId={props.popupId}/>));
    }
};

export default runCallbacks;
